// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"181":"08a2f865","594":"bfd3e8d1"}[chunkId] + ".js";
};